import FarmEvent from "@/FarmEvent"
import { list, object, serializable } from "serializr"
import Farm from "@/farm/Farm"
import util from "@/util"
import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import EffectType from "@/effects/EffectType"

export default class EventManager {
  @serializable(list(object(FarmEvent)))
  public events: any[] = []

  @serializable
  public lastEventTime: number = 0

  @serializable
  public nextEventTime: number = 30 + Math.random() * 90

  @serializable
  public lastDay: number = 0

  private get allRandomEvents(): any[] {
    return [
      {
        likelihood: 100,
        event: () => new FarmEvent((args: any) => {
          let admins = args.farm.getEmployeesAssignedTo('office')
          let money = Math.round(20 + 20 * Employee.totalIQ(admins).fraction * admins.length * Math.random())
          args.farm.state.money += money
          return `You found $${money}!`
        })
      },
      {
        likelihood: 20,
        requirement: (farm: Farm) => farm.state.employees.length >= 1,
        event: () => new FarmEvent((args: any) => {
          let employee: Employee = util.pickFrom(args.farm.state.employees, Math.random())
          let time = 30

          employee.effectManager.addTempEffect('event-sad', 'mood',
            new ValueMod(0.5, 'mul'),
            new EffectType(time, 'slow', 'reverting')
          )

          return `${employee.name} is feeling a bit sad and lonely. She could use some cheering up today!`
        })
      },
      {
        likelihood: 100,
        requirement: (farm: Farm) => farm.state.employees.length >= 1,
        event: () => new FarmEvent((args: any) => {
          let employee: Employee = util.pickFrom(args.farm.state.employees, Math.random())
          let time = (20 + 100 * Math.random()) * employee.constants['heatTimeMul']

          employee.effectManager.addTempEffect('event-heat', 'lustDelta',
            new ValueMod(employee.constants['heatLustMul'], 'mul'),
            new EffectType(time)
          )

          return `${employee.name} has gone into heat for ${util.displayTime(time)}!`
        })
      },
      {
        likelihood: 10,
        requirement: (farm: Farm) => farm.state.employees.length >= 1,
        event: () => new FarmEvent((args: any) => {
          let time = (20 + 100 * Math.random())
          for (let employee of args.farm.state.employees) {
            let employeeTime = time * employee.constants['heatTimeMul']
            employee.effectManager.addTempEffect('event-heat', 'lustDelta',
              new ValueMod(employee.constants['heatLustMul'], 'mul'),
              new EffectType(time)
            )
          }
          return `All employees have gone into heat for ${util.displayTime(time)}!`
        })
      },
      {
        likelihood: 10,
        requirement: (farm: Farm) => farm.state.employees.length >= 1,
        event: () => new FarmEvent((args: any) => {
          let employee: Employee = util.pickFrom(args.farm.state.employees, Math.random())
          let time = 60

          employee.effectManager.addTempEffect('event-bimbo-beer', 'iq',
            new ValueMod(0.5, 'mul'),
            new EffectType(time, 'slow', 'reverting')
          )

          employee.effectManager.addTempEffect('event-bimbo-beer', 'lustDelta',
            new ValueMod(2, 'mul'),
            new EffectType(time, 'slow', 'reverting')
          )

          employee.effectManager.addTempEffect('event-bimbo-beer', 'milkStorage',
            new ValueMod(1.5, 'mul'),
            new EffectType(time, 'slow', 'reverting')
          )

          return `Someone switched ${employee.name}'s drink for Bimbo Beer! She will get pretty ditzy and horny the coming ${util.displayTime(time * 2)}.`
        })
      },
    ]
  }

  update(dt: number, farm: Farm) {
    if (farm.state.employees.length > 0) this.lastEventTime += dt

    if (this.lastEventTime > this.nextEventTime) {
      this.addEvent(this.randomEvent(farm), farm)

      this.lastEventTime = 0
      this.nextEventTime = 20 + Math.random() * 100
    }

    // Daily event
    let day = Math.floor(util.timeToDays(farm.state.time))
    if (day != this.lastDay) {
      this.lastDay = day

      //this.addEvent(FarmEvent.milkPriceChangeEvent(), farm)
    }
  }

  load(state: any) {
    this.lastEventTime = state.lastEventTime
    this.nextEventTime = state.nextEventTime
  }

  addEvent(event: FarmEvent, farm: Farm) {
    event.takeAction(farm)

    this.events.unshift(event)
    if (this.events.length >= 10) {
      this.events = this.events.slice(0, this.events.length - 1)
    }
  }

  public randomEvent(farm: Farm, choice: number = -1): FarmEvent {
    if (choice == -1) choice = this.totalEventLikelihood(farm) * Math.random()
    let sum = 0
    for (let eventCreator of this.allRandomEvents) {
      if (eventCreator.requirement == undefined || eventCreator.requirement(farm)) {
        sum += eventCreator.likelihood
        if (sum >= choice) {
          return eventCreator.event()
        }
      }
    }
    return new FarmEvent(() => "Nothing happened.")
  }

  public totalEventLikelihood(farm: Farm): number {
    let sum = 0
    for (let eventCreator of this.allRandomEvents) {
      if (eventCreator.requirement == undefined || eventCreator.requirement(farm)) sum += eventCreator.likelihood
    }
    return sum
  }
}
